<template>
  <div class="institute-cooperation">
    <div class="institute-cooperation-title">高校合作</div>
    <div class="institute-cooperation-desc">
      <p>
        联合研发与理论突破：本公司与清华大学、复旦大学、浙江大学、山东大学及香港理工大学等知名院校建立紧密合作关系。
      </p>
    </div>
    <!-- <div class="institute-cooperation-domain">
      <div class="institute-cooperation-domain-title">社会治理领域</div>
      <p>
        <strong>浙江大学：</strong>
        华院计算与浙江大学承担国家重点课题《基层社会网格治理机制模型研究》，“数字化”赋能基层社会治理
      </p>
      <p>
        <strong>浙江大学高等研究院：</strong>
        华院计算与浙江大学高研院联合建立人工智能实验室，共同承担国家最高院《全类案智能审判研究》
      </p>
      <img :src="ecological_institute_cooperation_zj" alt="浙江大学">
      <p>
        <strong>清华大学：</strong>
        华院计算与清华大学社会科学学院建立基层社会治理研究中心，共同打造县域治理数字化模版
      </p>
      <img :src="ecological_institute_cooperation_qh" alt="清华大学">
      <p>
        <strong>交通大学：</strong>
        华院计算与上海交通大学智慧法院研究院成立联合研究中心，参与最高人民法院2021年度司法研究重大课题《矛盾纠纷源头治理体系化研究》，共同推动研究成果在基层社会治理场景的应用转化
      </p>
      <img :src="ecological_institute_cooperation_jt" alt="交通大学">
    </div> -->
    <!-- <div class="institute-cooperation-domain">
      <div class="institute-cooperation-domain-title">智能制造领域</div>
      <p>
        <strong>江西理工大学：</strong>
        华院计算与江西理工大学签署战略合作协议，共同促进人工智能技术在智能制造和冶金工业领域的前沿技术研究与科技成果转化，此外设立“华院奖学金”共同培养数据智能基础理论和应用的优秀学生
      </p>
      <img :src="ecological_institute_cooperation_jxlg" alt="江西理工大学：">
      <p>
        <strong>太原理工大学：</strong>
        与太原理工大学合作成立智慧煤焦产业创新联合实验室，致力于开展煤焦化的新技术应用，构建产学研创新新体系，将研究成果产业化，落地实际生产场景并助力人才培养，最终实现科研开发、科研成果转化与人才培养三大目标
      </p>
      <img :src="ecological_institute_cooperation_tylg" alt="太原理工大学">
      <p>
        <strong>郑州大学：</strong>
        与郑州大学成立河南省高温功能材料重点实验室耐火材料智能制造研发中心，将数字产业化和产业数字化结合，推动耐火材料工业全产业链高级化、现代化、安全化，加快迈入先进制造业
      </p>
      <img :src="ecological_institute_cooperation_zz" alt="郑州大学：">
    </div>
    <div class="institute-cooperation-domain">
      <div class="institute-cooperation-domain-title">智能制造领域</div>
      <p>
        <strong>复旦大学：</strong>
        华院计算与复旦大学大数据学院签署战略合作协议，开启长期深度合作，共同促进大数据产业生态建设。同时，华院计算创始人兼董事长宣晓华博士受聘为复旦大学大数据学院外聘教授，也是复旦大数据学院首位外聘教授
      </p>
      <p>
        <strong>上海财经大学：</strong>
        华院计算与上海财经大学数学学院签署产学研合作协议，促进数学学科研究与大数据人工智能技术及产业应用相结合
      </p>
    </div>
    <p>华院计算将持续与高校建立深入的科研合作关系，开展人工智能前沿技术研究，探索产学研创新合作及国际化合作之路</p> -->
  </div>
</template>
<script>
import ecological_institute_cooperation_zj from '@/../static/img/ecological/ecological_institute_cooperation_zj.png'
import ecological_institute_cooperation_qh from '@/../static/img/ecological/ecological_institute_cooperation_qh.png'
import ecological_institute_cooperation_jt from '@/../static/img/ecological/ecological_institute_cooperation_jt.png'
import ecological_institute_cooperation_jxlg from '@/../static/img/ecological/ecological_institute_cooperation_jxlg.png'
import ecological_institute_cooperation_tylg from '@/../static/img/ecological/ecological_institute_cooperation_tylg.png'
import ecological_institute_cooperation_zz from '@/../static/img/ecological/ecological_institute_cooperation_zz.png'
export default {
  data() {
    return {
      ecological_institute_cooperation_zj,
      ecological_institute_cooperation_qh,
      ecological_institute_cooperation_jt,
      ecological_institute_cooperation_jxlg,
      ecological_institute_cooperation_tylg,
      ecological_institute_cooperation_zz
    }
  },
}
</script>
<style lang="less" scoped>
.institute-cooperation {
  padding: 44px 64px 96px;
  text-align: center;
  background: #F8F9FB;

  .institute-cooperation-title {
    font-size: 40px;
    color: #08204D;
    line-height: 56px;
  }

  .institute-cooperation-desc {
    font-size: 24px;
    font-weight: 400;
    color: #08204D;
    line-height: 40px;
    text-align: left;
  }

  .institute-cooperation-domain {
    margin-top: 48px;

    .institute-cooperation-domain-title {
      font-size: 32px;
      color: #08204D;
      line-height: 44px;
    }

    >p {
      font-size: 24px;
      color: #08204D;
      line-height: 40px;
      text-align: left;
    }

    >img {
      width: 100%;
      height: 300px;
      margin: 32px 0;
    }
  }

  >p {
    font-size: 24px;
    color: #08204D;
    font-weight: bold;
    line-height: 40px;
    text-align: left;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/ecological/institute/cooperation.vue